var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gf-button',{attrs:{"variant":"secondary","after-icon":_vm.subscribtionIcon,"text":_vm.subscribtionText,"show-only-icon-mobile":true},on:{"click":_vm.onSubscribtionButtonClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }